export const centered = " flex items-center justify-center ";
export const flexer = " flex items-center justify-between ";
export const errorStyle = " text-RED text-left "
